module.exports = __webpack_public_path__ + "img/people-3-min.28331504.png";